import { render, staticRenderFns } from "./StateIconTag.vue?vue&type=template&id=2217d6bc"
import script from "./StateIconTag.vue?vue&type=script&lang=js"
export * from "./StateIconTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports